var map = {
	"./bn.json": 9141,
	"./en.json": 9937,
	"./ms.json": 3091,
	"./my.json": 7728,
	"./si.json": 378,
	"./ta.json": 395,
	"./th.json": 2600,
	"./zh.json": 2684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7641;